export const PropertiesSlugEnum = {
  TYPE: "type",
  SYMPTOM: "symptom",
  PATHOGEN: "pathogen",
  CATEGORY: "category",
};
